<template>
  <div ref="uploadDropTarget" class="upload-drop-target" @dragenter="onDragEnter">
    <div class="upload-drop-target-active" v-show="isDragActive || alwaysVisible" @dragenter="onDragEnter" @dragover="onDragOver" @dragleave="onDragLeave" @drop="onDrop">
      {{title}}
    </div>
    <slot/>    
  </div>
</template>

<style scoped>
.upload-drop-target {
  position: relative;
}
.upload-drop-target-active {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  font-size: 26px;
  background: rgba(255, 255, 255, .8);
  color: #676a6c;
  border: 3px dashed #808080;
  border-radius: 10px;
  z-index: 99999;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


<script>
export default {
  name: 'FormUploadDropTarget',
  props: {
    uploadAvailable: {
      type: Boolean,
      default: true
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Drop files here to upload'
    }
  },

  data() {
    return {
      isDragActive: false
    }
  },
  mounted() {
    if(this.hasDragDropSupport()) {
    }
  },
  beforeDestroy() {
  },
  methods: {
    hasDragDropSupport() {
      const targetEl = this.$refs.uploadDropTarget
      if(!('draggable' in targetEl) || !('ondragstart' in targetEl && 'ondrop' in targetEl))
        return false
      if(!('FormData' in window))
        return false
      if(!('FileReader' in window))
        return false

      return true
    },
    onDragEnter(event) {
      if(!this.uploadAvailable)
        return

      event.dataTransfer.dropEffect = 'copy'
      this.isDragActive = true

      event.preventDefault()
    },
    onDragOver(event) {
      if(!this.uploadAvailable)
        return

      event.preventDefault()
      event.stopPropagation()
      this.isDragActive = true
      
      event.dataTransfer.dropEffect = 'copy'
    },
    onDrop(event) {
      if(!this.uploadAvailable)
        return

      event.preventDefault()
      event.stopPropagation()

      this.isDragActive = false

      var fileList = []

      if(event.dataTransfer.items) {
        for(var i=0; i<event.dataTransfer.items.length; i++) {
          if(event.dataTransfer.items[i].kind === 'file') {
            var file = event.dataTransfer.items[i].getAsFile()
            fileList.push(file)
          }
        }
      } else {
        fileList = Array.prototype.slice.call(event.dataTransfer.files || [], 0)
      }

      if(fileList.length > 0) {
        this.$emit('filesDropped', fileList)
      }
    },
    onDragLeave(event) {
      if(!this.uploadAvailable)
        return
      event.preventDefault()

      this.isDragActive = false
    }
  }
}
</script>